export const appName = "Dobrá logistika";
